import React from "react";
import { Tabs, TabsList, TabsTrigger } from "../misc/Tabs";
import { ANALYTICS_WINDOWS, AnalyticsWindow } from "../../types/analytics";

interface WindowTabsProps {
    value: AnalyticsWindow;
    onChange: (w: AnalyticsWindow) => void;
    rangeLabel: string | null;
    className?: string;
}

const WindowTabs: React.FC<WindowTabsProps> = ({ value, onChange, rangeLabel, className }) => (
    <div className={className}>
        <Tabs
            value={String(value)}
            onValueChange={(v) => onChange(Number(v) as AnalyticsWindow)}
        >
            <TabsList className="w-fit">
                {ANALYTICS_WINDOWS.map((w) => (
                    <TabsTrigger key={w} value={String(w)} id={`analytics-window-${w}`}>
                        {w} days
                    </TabsTrigger>
                ))}
            </TabsList>
        </Tabs>
        {rangeLabel && (
            <p className="mt-2 text-sm text-gray-500">{rangeLabel}</p>
        )}
    </div>
);

export default WindowTabs;
